import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/contact", form); setSent(true); }
    catch { toast.error("Could not send message"); }
  };
  return (
    <div className="blz-container py-10 max-w-2xl">
      <h1 className="font-display text-3xl font-bold">Contact support</h1>
      <p className="text-slate-500 mt-1">Our team responds within 24 hours (business days).</p>
      {sent ? (
        <div className="mt-6 card-flat p-6">Thanks — your message has been received. Reference: <span className="font-mono">{form.email}</span></div>
      ) : (
        <form onSubmit={submit} className="mt-6 card-flat p-6 space-y-3">
          {[["name","Your name"],["email","Email"],["subject","Subject"]].map(([k,l]) => (
            <label key={k} className="block"><span className="text-xs font-semibold">{l}</span>
              <input required value={form[k]} onChange={(e) => setForm({...form, [k]: e.target.value})} className="mt-1 w-full h-11 rounded-lg border border-slate-200 px-3" data-testid={`contact-${k}`}/>
            </label>
          ))}
          <label className="block"><span className="text-xs font-semibold">Message</span>
            <textarea required rows={5} value={form.message} onChange={(e) => setForm({...form, message: e.target.value})} className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2" data-testid="contact-message"/>
          </label>
          <button className="btn-primary" data-testid="contact-submit">Send message</button>
        </form>
      )}
    </div>
  );
}
